import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { router } from './app/router';
import './i18n';
import { ApiError } from './lib/apiError';
import './styles/global.css';
import './styles/components.css';

/**
 * Einstiegspunkt.
 *
 * Zur Wiederholungsregel von TanStack Query: Ein 4xx wird **nicht**
 * wiederholt. Der Server hat verstanden und abgelehnt -- eine Wiederholung
 * ergibt dasselbe Ergebnis und verzoegert nur die Fehlermeldung. Wiederholt
 * wird, was nach einem voruebergehenden Problem aussieht: Netzfehler und
 * 5xx.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) =>
        !(error instanceof ApiError && error.isPermanent) && failureCount < 2,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      // Ein anlegender oder aendernder Aufruf wird nie von selbst wiederholt.
      // Ohne Idempotenzschluessel (docs/05, Abschnitt 6) entstuenden dabei
      // Dubletten -- und der Anwender saehe zwei Tickets, wo er eines
      // angelegt hat.
      retry: false,
    },
  },
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Das Wurzelelement #root fehlt in index.html.');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
